// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file api/v1/activity_service.proto (package journal.api.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_api_annotations } from "../../google/api/annotations_pb";
import { file_google_api_client } from "../../google/api/client_pb";
import { file_google_api_field_behavior } from "../../google/api/field_behavior_pb";
import { file_google_api_resource } from "../../google/api/resource_pb";
import type { Empty, Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file api/v1/activity_service.proto.
 */
export const file_api_v1_activity_service: GenFile = /*@__PURE__*/
  fileDesc("Ch1hcGkvdjEvYWN0aXZpdHlfc2VydmljZS5wcm90bxIOam91cm5hbC5hcGkudjEizQMKCEFjdGl2aXR5EhQKBG5hbWUYASABKAlCBuBBA+BBCBIUCgdjcmVhdG9yGAIgASgJQgPgQQMSMAoEdHlwZRgDIAEoDjIdLmpvdXJuYWwuYXBpLnYxLkFjdGl2aXR5LlR5cGVCA+BBAxIyCgVsZXZlbBgEIAEoDjIeLmpvdXJuYWwuYXBpLnYxLkFjdGl2aXR5LkxldmVsQgPgQQMSNAoLY3JlYXRlX3RpbWUYBSABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wQgPgQQMSNQoHcGF5bG9hZBgGIAEoCzIfLmpvdXJuYWwuYXBpLnYxLkFjdGl2aXR5UGF5bG9hZEID4EEDIjIKBFR5cGUSFAoQVFlQRV9VTlNQRUNJRklFRBAAEhQKDE1FTU9fQ09NTUVOVBABGgIIASI9CgVMZXZlbBIVChFMRVZFTF9VTlNQRUNJRklFRBAAEggKBElORk8QARIICgRXQVJOEAISCQoFRVJST1IQAzpP6kFMChdqb3VybmFsLmFwaS52MS9BY3Rpdml0eRIVYWN0aXZpdGllcy97YWN0aXZpdHl9GgRuYW1lKgphY3Rpdml0aWVzMghhY3Rpdml0eSJQCg9BY3Rpdml0eVBheWxvYWQSMgoMbWVtb19jb21tZW50GAEgASgLMhYuZ29vZ2xlLnByb3RvYnVmLkVtcHR5QgIYAUgAQgkKB3BheWxvYWQiPgoVTGlzdEFjdGl2aXRpZXNSZXF1ZXN0EhEKCXBhZ2Vfc2l6ZRgBIAEoBRISCgpwYWdlX3Rva2VuGAIgASgJIl8KFkxpc3RBY3Rpdml0aWVzUmVzcG9uc2USLAoKYWN0aXZpdGllcxgBIAMoCzIYLmpvdXJuYWwuYXBpLnYxLkFjdGl2aXR5EhcKD25leHRfcGFnZV90b2tlbhgCIAEoCSJDChJHZXRBY3Rpdml0eVJlcXVlc3QSLQoEbmFtZRgBIAEoCUIf4EEC+kEZChdqb3VybmFsLmFwaS52MS9BY3Rpdml0eTKHAgoPQWN0aXZpdHlTZXJ2aWNlEnsKDkxpc3RBY3Rpdml0aWVzEiUuam91cm5hbC5hcGkudjEuTGlzdEFjdGl2aXRpZXNSZXF1ZXN0GiYuam91cm5hbC5hcGkudjEuTGlzdEFjdGl2aXRpZXNSZXNwb25zZSIagtPkkwIUEhIvYXBpL3YxL2FjdGl2aXRpZXMSdwoLR2V0QWN0aXZpdHkSIi5qb3VybmFsLmFwaS52MS5HZXRBY3Rpdml0eVJlcXVlc3QaGC5qb3VybmFsLmFwaS52MS5BY3Rpdml0eSIq2kEEbmFtZYLT5JMCHRIbL2FwaS92MS97bmFtZT1hY3Rpdml0aWVzLyp9QrkBChJjb20uam91cm5hbC5hcGkudjFCFEFjdGl2aXR5U2VydmljZVByb3RvUAFaM2dpdGh1Yi5jb20veGluZ2h1aS92YWx1YXRpb24vcHJvdG8vZ2VuL2FwaS92MTthcGl2MaICA0pBWKoCDkpvdXJuYWwuQXBpLlYxygIOSm91cm5hbFxBcGlcVjHiAhpKb3VybmFsXEFwaVxWMVxHUEJNZXRhZGF0YeoCEEpvdXJuYWw6OkFwaTo6VjFiBnByb3RvMw", [file_google_api_annotations, file_google_api_client, file_google_api_field_behavior, file_google_api_resource, file_google_protobuf_empty, file_google_protobuf_timestamp]);

/**
 * @generated from message journal.api.v1.Activity
 */
export type Activity = Message<"journal.api.v1.Activity"> & {
  /**
   * The name of the activity.
   * Format: activities/{id}
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * The name of the creator.
   * Format: users/{user}
   *
   * @generated from field: string creator = 2;
   */
  creator: string;

  /**
   * The type of the activity.
   *
   * @generated from field: journal.api.v1.Activity.Type type = 3;
   */
  type: Activity_Type;

  /**
   * The level of the activity.
   *
   * @generated from field: journal.api.v1.Activity.Level level = 4;
   */
  level: Activity_Level;

  /**
   * The create time of the activity.
   *
   * @generated from field: google.protobuf.Timestamp create_time = 5;
   */
  createTime?: Timestamp;

  /**
   * The payload of the activity.
   *
   * @generated from field: journal.api.v1.ActivityPayload payload = 6;
   */
  payload?: ActivityPayload;
};

/**
 * Describes the message journal.api.v1.Activity.
 * Use `create(ActivitySchema)` to create a new message.
 */
export const ActivitySchema: GenMessage<Activity> = /*@__PURE__*/
  messageDesc(file_api_v1_activity_service, 0);

/**
 * Activity types.
 *
 * @generated from enum journal.api.v1.Activity.Type
 */
export enum Activity_Type {
  /**
   * Unspecified type.
   *
   * @generated from enum value: TYPE_UNSPECIFIED = 0;
   */
  TYPE_UNSPECIFIED = 0,

  /**
   * DEPRECATED: v0.73.0 - Comment feature removed
   *
   * @generated from enum value: MEMO_COMMENT = 1 [deprecated = true];
   * @deprecated
   */
  MEMO_COMMENT = 1,
}

/**
 * Describes the enum journal.api.v1.Activity.Type.
 */
export const Activity_TypeSchema: GenEnum<Activity_Type> = /*@__PURE__*/
  enumDesc(file_api_v1_activity_service, 0, 0);

/**
 * Activity levels.
 *
 * @generated from enum journal.api.v1.Activity.Level
 */
export enum Activity_Level {
  /**
   * Unspecified level.
   *
   * @generated from enum value: LEVEL_UNSPECIFIED = 0;
   */
  LEVEL_UNSPECIFIED = 0,

  /**
   * Info level.
   *
   * @generated from enum value: INFO = 1;
   */
  INFO = 1,

  /**
   * Warn level.
   *
   * @generated from enum value: WARN = 2;
   */
  WARN = 2,

  /**
   * Error level.
   *
   * @generated from enum value: ERROR = 3;
   */
  ERROR = 3,
}

/**
 * Describes the enum journal.api.v1.Activity.Level.
 */
export const Activity_LevelSchema: GenEnum<Activity_Level> = /*@__PURE__*/
  enumDesc(file_api_v1_activity_service, 0, 1);

/**
 * DEPRECATED: v0.73.0 - Comment feature removed
 * ActivityPayload type is no longer used but kept for backward compatibility
 *
 * @generated from message journal.api.v1.ActivityPayload
 */
export type ActivityPayload = Message<"journal.api.v1.ActivityPayload"> & {
  /**
   * @generated from oneof journal.api.v1.ActivityPayload.payload
   */
  payload: {
    /**
     * Placeholder field to satisfy oneof requirement
     * DEPRECATED: v0.73.0 - Comment feature removed
     *
     * @generated from field: google.protobuf.Empty memo_comment = 1 [deprecated = true];
     * @deprecated
     */
    value: Empty;
    case: "memoComment";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message journal.api.v1.ActivityPayload.
 * Use `create(ActivityPayloadSchema)` to create a new message.
 */
export const ActivityPayloadSchema: GenMessage<ActivityPayload> = /*@__PURE__*/
  messageDesc(file_api_v1_activity_service, 1);

/**
 * @generated from message journal.api.v1.ListActivitiesRequest
 */
export type ListActivitiesRequest = Message<"journal.api.v1.ListActivitiesRequest"> & {
  /**
   * The maximum number of activities to return.
   * The service may return fewer than this value.
   * If unspecified, at most 100 activities will be returned.
   * The maximum value is 1000; values above 1000 will be coerced to 1000.
   *
   * @generated from field: int32 page_size = 1;
   */
  pageSize: number;

  /**
   * A page token, received from a previous `ListActivities` call.
   * Provide this to retrieve the subsequent page.
   *
   * @generated from field: string page_token = 2;
   */
  pageToken: string;
};

/**
 * Describes the message journal.api.v1.ListActivitiesRequest.
 * Use `create(ListActivitiesRequestSchema)` to create a new message.
 */
export const ListActivitiesRequestSchema: GenMessage<ListActivitiesRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_activity_service, 2);

/**
 * @generated from message journal.api.v1.ListActivitiesResponse
 */
export type ListActivitiesResponse = Message<"journal.api.v1.ListActivitiesResponse"> & {
  /**
   * The activities.
   *
   * @generated from field: repeated journal.api.v1.Activity activities = 1;
   */
  activities: Activity[];

  /**
   * A token to retrieve the next page of results.
   * Pass this value in the page_token field in the subsequent call to `ListActivities`
   * method to retrieve the next page of results.
   *
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;
};

/**
 * Describes the message journal.api.v1.ListActivitiesResponse.
 * Use `create(ListActivitiesResponseSchema)` to create a new message.
 */
export const ListActivitiesResponseSchema: GenMessage<ListActivitiesResponse> = /*@__PURE__*/
  messageDesc(file_api_v1_activity_service, 3);

/**
 * @generated from message journal.api.v1.GetActivityRequest
 */
export type GetActivityRequest = Message<"journal.api.v1.GetActivityRequest"> & {
  /**
   * The name of the activity.
   * Format: activities/{id}, id is the system generated auto-incremented id.
   *
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message journal.api.v1.GetActivityRequest.
 * Use `create(GetActivityRequestSchema)` to create a new message.
 */
export const GetActivityRequestSchema: GenMessage<GetActivityRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_activity_service, 4);

/**
 * @generated from service journal.api.v1.ActivityService
 */
export const ActivityService: GenService<{
  /**
   * ListActivities returns a list of activities.
   *
   * @generated from rpc journal.api.v1.ActivityService.ListActivities
   */
  listActivities: {
    methodKind: "unary";
    input: typeof ListActivitiesRequestSchema;
    output: typeof ListActivitiesResponseSchema;
  },
  /**
   * GetActivity returns the activity with the given id.
   *
   * @generated from rpc journal.api.v1.ActivityService.GetActivity
   */
  getActivity: {
    methodKind: "unary";
    input: typeof GetActivityRequestSchema;
    output: typeof ActivitySchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_api_v1_activity_service, 0);

